import { gql } from '@apollo/client';

const commonJobSeekerFragment = gql`
  fragment CommonJobSeekerFragment on JobSeeker {
    id
    email
    phone
    firstName
    lastName
    image
    address
    placeOfBirth
    status
    birthday
    desiredJobTypes
    desiredWorkLocations
    desiredCompanySizes
    studyKeywords
    studyDetail
    certifications
    focusSummary
    focusDetail
    thingsChangedAfterCovid
    toeicScore
    educationHistory {
      id
      name
      course
      faculty
      department
      grade
      graduatedOn
      major
      researchDetail
      researchSubject
      highSchool
    }
  }
`;

const mySocialAccounts = gql`
  query MySocialAccounts {
    jobSeekerMe {
      id
      isInternal
      socialAccounts {
        provider
        profileUrl
      }
    }
  }
`;

const myAchievements = gql`
  query MyAchievements {
    jobSeekerMe {
      id
      achievements {
        id
        title
        url
        description
        date
        attachment
      }
    }
  }
`;

const myProfile = gql`
  ${commonJobSeekerFragment}

  query JobSeekerMe {
    jobSeekerMe {
      introducedByName
      isInternal
      ...CommonJobSeekerFragment
    }
  }
`;

const updateProfile = gql`
  ${commonJobSeekerFragment}

  mutation UpdateProfile($input: UpdateJobSeekerInput!) {
    updateJobSeeker(input: $input) {
      ...CommonJobSeekerFragment
    }
  }
`;

const associateSocialAccount = gql`
  mutation associateSocialAccount($input: AssociateSocialAccountInput!) {
    associateSocialAccount(input: $input) {
      provider
      profileUrl
    }
  }
`;

const disassociateSocialAccount = gql`
  mutation disassociateSocialAccount($provider: SocialAccountProvider!) {
    disassociateSocialAccount(provider: $provider) {
      success
    }
  }
`;

const createAchievement = gql`
  mutation createAchievement($input: AchievementInput!) {
    createAchievement(input: $input) {
      id
      title
      url
      description
      date
      attachment
    }
  }
`;

const updateAchievement = gql`
  mutation updateAchievement($id: String!, $input: AchievementInput!) {
    updateAchievement(id: $id, input: $input) {
      id
      title
      url
      description
      date
      attachment
    }
  }
`;

const deleteAchievement = gql`
  mutation deleteAchievement($id: String!) {
    deleteAchievement(id: $id) {
      success
    }
  }
`;

export {
  updateProfile,
  myProfile,
  mySocialAccounts,
  associateSocialAccount,
  disassociateSocialAccount,
  myAchievements,
  createAchievement,
  updateAchievement,
  deleteAchievement,
};
